<!--
 * @Description: 
 * @version: 1.0.0
 * @Author: zhangxin
 * @Date: 2021-04-14 14:19:15
 * @LastEditors: youqixin
 * @LastEditTime: 2021-04-14 14:20:07
-->
<template>
  <div
    class="login-out"
    ref="logout"
    v-clickoutside="clickoutside"
    id="logout"
    v-if="show"
  >
    <div class="login-hover">
      <div class="login-info-hover">
        <div class="login-content">
          <p class="login-code">{{ userCode }}</p>
          <p class="login-name">{{ userName }}</p>
          <div class="login-order flex justify-between">
            <p @click="goTo('/project/list?channel=xshop')">报价</p>
            <p @click="goTo('/order/list')">订单</p>
          </div>
          <p class="log-out" @click="logOut">退出登录</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const clickoutside = {
  bind(el, binding) {
    function handler(e) {
      if (
        el.contains(e.target) ||
        e.target.className.includes(binding.arg) ||
        e.target.className.indexOf("clickOut") > -1
      ) {
        return false;
      }
      if (binding.expression) {
        binding.value(e);
      }
    }
    el._zClickOutside = handler;
    document.addEventListener("click", handler);
  },
  unbind(el) {
    document.removeEventListener("click", el._zClickOutside);
    delete el._zClickOutside;
  },
};
import jwt_decode from "jwt-decode";
import router from "@/router";
export default {
  name: "Logout",
  data() {
    return {
      designProjectCount: "",
      order: "",
      userName: "",
      userCode: "",
      show: false,
    };
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.loginNow();
      }
    },
  },
  directives: { clickoutside },
  methods: {
    loginNow() {
      let token = localStorage.getItem("users.access_token");
      const user = jwt_decode(token);
      // console.log(jwt_decode(token))
      this.userName = user.UserName;
      this.userCode = user.Mobile;
    },
    clickoutside() {
      this.show = false;
    },
    close() {
      this.show = false;
    },
    goIntentionSelf() {
      document.body.removeChild(this.$el);
      router.push("/project/list");
    },
    goTo(href) {
      window.location.href = href;
    },
    logOut() {
      localStorage.clear();
      window.location.href = "/";
      // console.log(router);
      // alert(router);
      // if (router.path == "/" || router.path == undefined) {
      //   // router.go(0);
      //   location.href = "/";
      //   localStorage.clear();
      //   document.body.removeChild(this.$el);
      //   // console.log("123");
      //   window.location.reload();
      //   // router.replace({
      //   //   name: "Index"
      //   // });
      // } else {
      //   location.href = "/";
      //   localStorage.clear();
      //   document.body.removeChild(this.$el);
      // }
    },
    onClickOutside: function (e) {
      // document.body.removeChild(this.$el);
      // console.log();
      if (e.target.className.indexOf("clickOut") >= 0) {
        this.show = !this.show;
      } else {
        this.show = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.login-out {
  div {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .login-hover {
    width: 440px;
    height: 400px;
    position: fixed;
    right: 50px;
    top: 70px;
    // display: none;
    text-align: center;
    z-index: 1000;
    // overflow: hidden;
  }
  .z-in {
    // display: block;
    // height: 400px;
  }
  .login-info-hover {
    border: 1px solid #979797;
    border-radius: 8px;
    margin-top: 16px;
    background: #fff;
    width: 440px;
    height: 382px;
  }
  .login-content {
    padding: 30px 60px 40px;
  }
  .login-code {
    font-size: 20px;
    color: #333333;
  }
  .login-name {
    margin-top: 40px;
    font-size: 26px;
    color: #333333;
  }
  .login-order {
    margin-top: 38px;
    overflow: hidden;
    font-size: 16px;
    color: #333333;
    line-height: 48px;
    p {
      width: 146px;
      background: #ffffff;
      border: 1px solid #333333;
      border-radius: 3px;
      cursor: pointer;
    }
  }
  .log-out {
    background: #b92500;
    border-radius: 3px;
    width: 320px;
    height: 48px;
    line-height: 48px;
    font-size: 20px;
    color: #ffffff;
    margin-top: 50px;
    cursor: pointer;
  }
}
</style>
